export const countUniqueSearchesOnClientId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.search.view',
  key: 'countUniqueSearchesOnClientId',
  targetProperty: 'actor.client.id',
}
